import React, { useState } from "react";
import { ChatProperty } from "../types";

// Total number of property images available
const TOTAL_PROPERTY_IMAGES = 73;

export const PropertyCard = ({
  property,
}: {
  property: ChatProperty;
}) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // Calculate image number based on property id using modulo
  const getPropertyImage = () => {
    // If property has a specific image, use it
    if (property.image) {
      return property.image;
    }
    
    // Otherwise, calculate image from property id
    const imageNumber = (property.id % TOTAL_PROPERTY_IMAGES) + 1;
    return `/public/properties/${imageNumber}.jpg`;
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  return (
    <a
      href={`#property-${property.slug}`}
      className="block w-full cursor-pointer overflow-hidden rounded-2xl bg-white shadow-md transition-all hover:shadow-xl"
    >
      <div className="relative h-[172px] w-full overflow-hidden bg-gray-100">
        {imageLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-50">
            <div className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-[#5a2d5f]" />
          </div>
        )}
        <img
          src={getPropertyImage()}
          alt={property.title}
          className={`h-[172px] w-full object-cover transition-opacity ${imageLoading ? "opacity-0" : "opacity-100"}`}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ display: imageLoading ? "none" : "block" }}
        />
        {imageError && !imageLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 text-sm text-gray-400">
            <span>No Image</span>
          </div>
        )}
      </div>

      <div className="border-t border-gray-300 bg-gradient-to-r from-[#D14081] to-[#2A1745] p-4 text-white">
        <h4 className="mb-2 text-sm font-semibold">{property.title}</h4>
        <div className="mb-1 text-sm font-medium">{property.price}</div>
        <div className="mb-2 text-xs opacity-90">{property.location}</div>
        <div className="mb-2 text-xs opacity-90">
          {property.bedrooms} beds / {property.bathrooms} baths
          {property.built_size && ` / ${property.built_size} SQM`}
        </div>
        <div className="text-xs opacity-80">{property.description}</div>
      </div>
    </a>
  );
};

